import AUIEllipsis from '@ancert/aui-ellipsis';
/**
 * @typedef {import('../../interfaces/AUI/IDropdownButton.interface').IDropdownButtonItem} IDropdownButtonItem
 */

import React from 'react';
import { format } from 'date-fns';

const getColumns = () => [
  {
    id: 'usuario',
    accessor: (row) => row,
    header: 'Usuario',
    cell: ({ value }) => {
      const { name, lastname1, lastname2 } = value;
      let fullName = 'Anónimo';
      if (name) {
        fullName = `${name} ${lastname1}${lastname2 ? ` ${lastname2}` : ''}`;
      }
      return <AUIEllipsis content={fullName}/>;
    },
  },
  {
    id: 'documentType',
    accessor: (row) => row.documentType,
    columnWidth: 120,
    header: 'Tipo documento',
    cell: ({ value }) => <AUIEllipsis content={value ?? ''}/>,
  },
  {
    id: 'dni',
    accessor: (row) => row.document,
    columnWidth: 100,
    header: 'Doc. identidad',
    cell: ({ value }) => <AUIEllipsis content={value ?? ''}/>,
  },
  {
    id: 'email',
    accessor: (row) => row.email,
    columnWidth: 280,
    header: 'Correo electrónico',
    cell: ({ value }) => <AUIEllipsis content={value ?? ''}/>,
  },
  {
    id: 'rol',
    accessor: (row) => row.role,
    columnWidth: 136,
    header: 'Rol',
    cell: ({ value }) => <>{value ? `${value?.charAt(0).toUpperCase()}${value?.slice(1).toLowerCase()}` : ''}</>,
  },
  {
    id: 'fecha',
    accessor: (row) => row.creationDate,
    header: 'Fecha',
    columnWidth: 96,
    cell: ({ value }) => <>{format(new Date(value), 'dd/MM/yyyy')}</>,
  },
  {
    id: 'status',
    accessor: (row) => row.active,
    header: 'Estado',
    columnWidth: 64,
    cell: ({ value }) => <>{value ? 'Activo' : 'Inactivo'}</>,
  },
];

export default getColumns;
